import React from 'react';
// can be used to disable lazy loading for an entire subtree
const LazyContext = /*#__PURE__*/ React.createContext(false);
LazyContext.displayName = 'LazyContext';
export default LazyContext;
